export type DsAlertBannerVariant = 'warning' | 'error' | 'info';

export const DS_ALERT_BANNER_VARIANT_ICONS: Record<DsAlertBannerVariant, string> = {
    warning: 'fa-exclamation-circle',
    error: 'fa-exclamation-triangle',
    info: 'fa-info-circle',
};

export interface DsAlertBannerProps {
    variant: DsAlertBannerVariant;
    title?: string;
}
